'use client';

export default function GoalMarketingLoadingSkeleton() {
  return (
    <div className="w-full h-full">
      <div className="bg-white flex flex-col gap-4 font-medium rounded-t-xl md:rounded-lg h-full justify-between animate-pulse">
        <div className="pt-4 px-4">
          <div className="h-6 w-48 bg-gray-200 rounded"></div>
          <div className="h-4 w-32 bg-gray-200 rounded mt-2"></div>
        </div>
        <div className="px-4">
          <div className="h-[1px] w-full bg-gray-200"></div>
          <div className="h-5 w-32 bg-gray-200 rounded mt-2"></div>
          <div className="grid grid-cols-4 gap-2 mt-2">
            {[1, 2, 3, 4].map(item => (
              <div key={item} className="h-10 bg-gray-200 rounded-[30px]"></div>
            ))}
          </div>
        </div>
        <div className="px-4">
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-4 w-64 bg-gray-200 rounded mt-2"></div>
        </div>
        <div className="px-4 mb-4">
          <div className="h-6 w-24 bg-gray-200 rounded"></div>
          <div className="h-12 w-full bg-gray-200 rounded mt-2"></div>
        </div>
      </div>
    </div>
  );
}

